(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('NewOrderController', NewOrderController);

  /* ngInject */
  function NewOrderController($state, $stateParams, Flash, sessionService, orderService, formErrorsService, stripePlanService, usStates, fiTypes, paymentTypes) {
    const vm = this;

    angular.extend(vm, formErrorsService);
    angular.extend(vm, stripePlanService);

    vm.activate = activate;
    vm.createOrder = createOrder;
    vm.orderForm = {};
    vm.order = {fi_type: 'bank', payment_type: 'credit_card'};
    vm.fiTypes = fiTypes;
    vm.states = usStates;
    vm.stripePlans = {};
    vm.getStripePlans = getStripePlans;
    vm.paymentTypes = paymentTypes;

    vm.activate();

    function activate() {
      vm.getStripePlans();
    }

    function getStripePlans() {
      stripePlanService(sessionService.getAuthToken()).query(response => {vm.stripePlans = response;});
    }

    function createOrder(order) {
      vm.clearFormErrors();
      orderService(sessionService.getAuthToken()).save({order}, _createOrderSuccess, _createOrderFailure);
    }

    function _createOrderSuccess(_response) {
      Flash.create('success', 'The order was successfully created.');
      $state.go('application.compliance_framework.orders');
    }

    function _createOrderFailure(response) {
      vm.setFormErrors(vm.orderForm, response);
    }

  }
})();
